module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-23-8ab45f23c03f4b7ff4ba7b3be10f51eb.svg";